<script setup lang="ts">
import {defineProps} from "vue";
const props = defineProps({
  galleries:{ type: Array, default: () => [] },
  galleryTypes:{ type: Array, default: () => [] }
});

console.log("Test------------------")
console.log(props.galleries)
</script>

<template>
  <div class="uk-padding csa-gallery-mg">
    <div class="uk-container">

      <div data-uk-filter="target: .js-filter" >
        <!-- gallery filter -->
        <ul class="uk-subnav uk-subnav-pill uk-flex-center uk-margin-medium-bottom impx-gallery-filter uk-margin-small-top impx-margin-bottom">
          <li data-uk-filter-control=".all"><a href="#">Tout</a></li>
          <li
              v-for="type in galleryTypes"
              :key="type.uid"
              :data-uk-filter-control="'.' + type.uid"
          >
            <a href="#">{{type.label}}</a></li>
        </ul>
        <!-- gallery filter end -->

        <!-- gallery items -->
        <div class="js-filter uk-child-width-1-4@xl uk-child-width-1-4@l uk-child-width-1-4@m uk-child-width-1-3@s uk-grid-medium uk-margin-small-bottom" data-uk-grid="masonry : true" data-uk-lightbox>
          <div :class="'.' + galleryImg.type+'  all'" :key="index" v-for="(galleryImg, index) in galleries"><!-- gallery item #1 -->
            <a class="uk-inline-clip uk-transition-toggle" :href="galleryImg.url" :data-caption="galleryImg.title">
              <img :src="galleryImg.url" :alt="galleryImg.title">
              <div class="uk-transition-fade uk-position-cover uk-overlay uk-overlay-primary">
                <h5>{{galleryImg.title}}</h5>
<!--                <p>{{galleryImg.desc}}</p>-->
              </div>
            </a>
          </div>
          <!-- gallery item #1 end -->
        </div>
        <!-- gallery items end -->
      </div>

    </div>
  </div>

</template>

<style scoped>

</style>